import { render, staticRenderFns } from "./GameGreenRoom.vue?vue&type=template&id=4d687cac&"
import script from "./GameGreenRoom.vue?vue&type=script&lang=js&"
export * from "./GameGreenRoom.vue?vue&type=script&lang=js&"
import style0 from "./GameGreenRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d687cac')) {
      api.createRecord('4d687cac', component.options)
    } else {
      api.reload('4d687cac', component.options)
    }
    module.hot.accept("./GameGreenRoom.vue?vue&type=template&id=4d687cac&", function () {
      api.rerender('4d687cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameGreenRoom.vue"
export default component.exports